import { render, staticRenderFns } from "./ParticipateBox.vue?vue&type=template&id=1548fc4f&scoped=true&"
import script from "./ParticipateBox.vue?vue&type=script&lang=js&"
export * from "./ParticipateBox.vue?vue&type=script&lang=js&"
import style0 from "./ParticipateBox.vue?vue&type=style&index=0&id=1548fc4f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1548fc4f",
  null
  
)

export default component.exports